import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/styled-system'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const ContactEventParts = [
  'container',
  'dateText',
  'typeContainer',
  'typeIcon',
  'typeText',
  'numbersContainer',
  'fromNumberText',
  'arrowIcon',
  'toNumberText',
] as const

const helpers = createMultiStyleConfigHelpers(ContactEventParts)

export const ContactEventStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexDirection: 'column',
      height: '7.5rem',
      marginTop: '-0.1rem',
      paddingX: '0.75rem',
      gap: '0.25rem',
    },
    dateText: {
      textStyle: textStyleKeys.Body2_Bold,
    },
    typeContainer: {
      alignItems: 'center',
      gap: '0.25rem',
    },
    typeIcon: {
      boxSize: '1rem',
    },
    typeText: {
      textStyle: textStyleKeys.Body2,
    },
    numbersContainer: {
      align: 'center',
      gap: '0.5rem',
    },
    fromNumberText: {
      textStyle: textStyleKeys.Body2,
    },
    arrowIcon: {
      boxSize: '0.75rem',
      mt: '0.28rem',
    },
    toNumberText: {
      textStyle: textStyleKeys.Body2,
    },
  },
})

export const useContactEventStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof ContactEventParts>(
    getName({ ContactEventStyle }),
    props,
  )
}
